<template>
  <v-dialog v-model="dialog" width="700" >
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">Yokkameについて</span>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Yokkameについて</span>
      </v-card-title>
      <v-card-text style="white-space:pre-wrap; word-wrap:break-word;">&nbsp;{{whatIsYokkame}}</v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      whatIsYokkame: `このアプリは学習など継続して何かを行いたい事を期間を決めてチェックする事で習慣にする事を目的としたアプリです。
明瞭な操作性で直感的でストレスフリーに利用することが可能です。また、相互フォローによる「友達機能」で相互のアクションを共有できたり、「グループ機能」によって同じ目的を持ったコミュニティを形成することが可能です。
「コメント」や「イイね」、「経験値」などお客様に楽しくご利用いただけるよう様々な機能を実装しております！このアプリを利用することで少しでもモチベーションアップのお手伝いができる事を説に願っております。`,
      dialog: false,
    };
  },
};
</script>
